// Copyright (c) 2017 Deere & Company

import {
    addFile,
    deleteFile
} from './file-attachment';
import {
    addLabor,
    changeHours,
    changeLaborComments,
    changeLaborLocation,
    changeLaborType,
    changeTechId,
    deleteLabor
} from './labor';
import {
    addPart,
    changePartProperty,
    changePartsUnit,
    deletePart
} from './parts';
import {
    changeAmount,
    changeComments,
    changeDescription,
    changeDistance,
    createOtherCredit,
    deleteOtherCredit
} from './other-credits';
import {
    onCreateClaim,
    updateCreateIncentiveClaimModalVisibility,
    updateIncentiveClaimModalMode
} from './create-incentive-claim-modal-visibility';
import {
    resetConfirmationModal,
    setConfirmationModal
} from './confirmation-modal';

import {
    resetIncentiveClaim,
    updateIncentiveClaimFailurePart,
    updateIncentiveClaimInputOnBlur,
    updateIncentiveClaimPin,
    updateIncentiveClaimRepairDate,
    updateIncentiveClaimRepairNumber,
    updateIncentiveClaimUnitDropDown,
    updateIncentiveClaimUseAmount,
    updateIncentiveClaimWorkOrderOne,
    updateIncentiveClaimWorkOrderTwo,
    updateIncentiveCustomerName,
    updateIncentiveEmail,
    updateResponsibleAccountsDropDown,
    updateSelectedProgramDropDown
} from './claim-incentive-details';

import {
    updateNonTrackedPinModalAccount,
    updateNonTrackedPinModalFailureDate,
    updateNonTrackedPinModalInvoiceDate,
    updateNonTrackedPinModalInvoiceNumber,
    updateNonTrackedPinModalPin,
    updatePin
} from './pin';
import {additionalRepair} from './additional-repair';
import {copyAttachments} from '../../shared/action-creators/copy-attachment';
import {copyClaim} from './copy-claim';
import {createPin} from './create-pin';
import {onEditClaim} from '../../shared/action-creators/edit-claim';
import {readClaimProduct} from './get-product-details';
import {readIncentiveClaim} from './get-incentive-claim';
import {readOtherCreditDescriptions} from '../../shared/action-creators/other-credit-descriptions';
import {readPartDetails} from './get-part-details';
import {resetCkcCustomerFailure} from '../../../shared/action-creators/customer-failed';
import {resetCustomerDetails} from './reset-customer-details';
import {resetProductDetails} from './reset-product-details';
import {toggleWarrentyStatusModal} from '../../shared/action-creators/warranty-status-modal';
import {updateIsEditable} from './is-editable';
import {updateNonTrackedPinModalVisibility} from './non-tracked-pin-modal-visibility';
import {updateSelectedAction} from './update-selected-action';
import {updateTemporaryObjectKey} from './update-temporary-object-key';
import {updateWarranties} from '../../../product/details/action-creators/warranties';

export default {
    addFile,
    addLabor,
    addPart,
    additionalRepair,
    changeAmount,
    changeComments,
    changeDescription,
    changeDistance,
    changeHours,
    changeLaborComments,
    changeLaborLocation,
    changeLaborType,
    changePartProperty,
    changePartsUnit,
    changeTechId,
    copyAttachments,
    copyClaim,
    createOtherCredit,
    createPin,
    deleteFile,
    deleteLabor,
    deleteOtherCredit,
    deletePart,
    onCreateClaim,
    onEditClaim,
    readClaimProduct,
    readIncentiveClaim,
    readOtherCreditDescriptions,
    readPartDetails,
    resetCkcCustomerFailure,
    resetConfirmationModal,
    resetCustomerDetails,
    resetIncentiveClaim,
    resetProductDetails,
    setConfirmationModal,
    toggleWarrentyStatusModal,
    updateCreateIncentiveClaimModalVisibility,
    updateIncentiveClaimFailurePart,
    updateIncentiveClaimInputOnBlur,
    updateIncentiveClaimModalMode,
    updateIncentiveClaimPin,
    updateIncentiveClaimRepairDate,
    updateIncentiveClaimRepairNumber,
    updateIncentiveClaimUnitDropDown,
    updateIncentiveClaimUseAmount,
    updateIncentiveClaimWorkOrderOne,
    updateIncentiveClaimWorkOrderTwo,
    updateIncentiveCustomerName,
    updateIncentiveEmail,
    updateIsEditable,
    updateNonTrackedPinModalAccount,
    updateNonTrackedPinModalFailureDate,
    updateNonTrackedPinModalInvoiceDate,
    updateNonTrackedPinModalInvoiceNumber,
    updateNonTrackedPinModalPin,
    updateNonTrackedPinModalVisibility,
    updatePin,
    updateResponsibleAccountsDropDown,
    updateSelectedAction,
    updateSelectedProgramDropDown,
    updateTemporaryObjectKey,
    updateWarranties
};



// WEBPACK FOOTER //
// ./src/claim/incentive/action-creators/index.js